<template>
  <div class="modal fade" :id="'email-pdf-modal-'+modalId" role="dialog" aria-labelledby="emailPdfLabel"
       aria-hidden="true">
    <div class="modal-dialog automation-email-modal-dialog automation-pdf-modal modal-sm" role="emailPdf">
      <div class="modal-content">
        <div class="modal-header" style="cursor: move">
          Select PDFs
        </div>
        <div class="modal-body">
          <select class="pdf-selectpicker" multiple v-model="selectedPdfListModel">
            <option v-for="template in templateList" :value="template.id" v-if="template.type == 'pdf'">
              {{ template.name }}
            </option>
          </select>
        </div>
        <div class="modal-footer test-modal-footer">
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="PdfModalClose">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'modalId',
    'templateList',
    'selectedPdfList',
  ],
  data() {
    return {}
  },
  mounted() {
    $('.pdf-selectpicker').selectpicker();
  },
  watch: {
    selectedPdfList(newvalue, oldvalue) {

      var placeholder = [];

      if (newvalue) {
        for (var pdf in newvalue) {
          var _index = this.templateList.findIndex(x => x.id == newvalue[pdf]);
          if (_index > -1) {
            placeholder.push(this.templateList[_index].name);
          }
        }

        if (this.selectedPdfList.length > 0) {
          $('#email-pdf-modal-' + this.modalId).find('.filter-option-inner-inner').html(placeholder.join(', '));
        } else {

          $('#email-pdf-modal-' + this.modalId).find('.filter-option-inner-inner').html('Nothing selected');
          $('#email-pdf-modal-' + this.modalId).find('.dropdown-toggle').addClass('bs-placeholder');
          $('#email-pdf-modal-' + this.modalId).find('.dropdown-toggle').prop({
            title: 'Nothing selected',
          });
        }
      }
    }
  },
  computed: {
    selectedPdfListModel: {
      get: function () {
        return this.selectedPdfList;
      },
      set: function (value) {
        this.$emit('pdflistchangedEvent', value);
      }
    }
  },
  methods: {
    PdfModalClose() {
      $('#email-pdf-modal-' + this.modalId).modal('hide');
    }
  }
}
</script>